import { render, staticRenderFns } from "./LeadDetail.vue?vue&type=template&id=37cc2858&scoped=true"
import script from "./LeadDetail.vue?vue&type=script&lang=js"
export * from "./LeadDetail.vue?vue&type=script&lang=js"
import style0 from "./LeadDetail.vue?vue&type=style&index=0&id=37cc2858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc2858",
  null
  
)

export default component.exports